module.exports = "<div class=container-fluid _v-cef6d4b8=\"\"><div class=col-md-12 _v-cef6d4b8=\"\"><h1 _v-cef6d4b8=\"\">{{msg}}</h1></div></div>";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-cef6d4b8!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/pages/Index.vue
// module id = 302
// module chunks = 2